import React from 'react';
import { GreenSpacerTag } from './styled';
const GreenSpacer = ({ spacer }) => React.createElement(GreenSpacerTag, { style: { height: spacer } });
export default GreenSpacer;
